<template>
	<div style="border: 1px solid #ccc;">
		<Toolbar ref="toolbar" style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
			:mode="mode" />
		<Editor ref="ueditor" style="height: 500px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig"
			:mode="mode" @onCreated="onCreated" />
	</div>
</template>

<script>
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'
	import {
		DomEditor
	} from '@wangeditor/editor'
	export default {
		name: '',
		props: {
			placeholder:{
				type:String,
				default:'请输入'
			}
		},
		components: {
			Editor,
			Toolbar
		},
		data() {
			return {
				editor: null,
				html: '',
				toolbarConfig: {
					excludeKeys: [
						"deleteImage",
						"editImage",
						"viewImageLink",
						"imageWidth30",
						"imageWidth50",
						"imageWidth100",
						"insertImage",
						"uploadImage",
						"uploadVideo",
						"insertVideo",
					]
				},
				editorConfig: {
					placeholder: this.placeholder,
				},
				mode: 'default', // or 'simple'
			}
		},
		created() {},
		mounted() {

		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
			this.editor = null
		},
		methods: {
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
				// console.log(this.editor.getAllMenuKeys(), 1231312)
			},
			setHtml(html){
				this.editor.setHtml(html)
			},
			getHtml(){
				return this.editor.getHtml()
			}
		}

	}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
	.container {}
</style>